import RefreshTokenApi from '@/api/RefreshTokenApi';
import router from '@/router/index.router';
import { useMixpanelService } from '@/services/MixpanelService';
import useZendeskService from '@/services/ZendeskService';

class SessionManager {

	private isRefreshing = false;
	private promise?: Promise<any>;

	constructor () {
		const userType = localStorage.getItem('userType');
		const requiredAuth = router.currentRoute.value?.matched?.findIndex(x => x.meta.requiresAuth) !== -1;

		if (!userType && router.currentRoute.value?.name !== 'Login' && requiredAuth) router.push({ name: 'Login' });
	}

	async getTokenAsync () {
		try {
			if (this.isRefreshing) {
				return this.promise;
			}
			else {
				this.isRefreshing = true;
				this.promise = RefreshTokenApi.refreshToken();

				await this.promise?.finally(() => {
					this.promise = undefined;
					this.isRefreshing = false;
				});
			}
			return true;
		}
		catch (error) {
			return false;
		}
	}

	async logoutAsync () {
		localStorage.removeItem('userType');
		useMixpanelService().track('user.logout');
		useMixpanelService().reset();
		await useZendeskService().resetAsync();
		RefreshTokenApi.logout();
	}

}

const sessionManager = new SessionManager();

export default sessionManager;
